import {
  ComboboxButton as HeadlessComboboxButton,
  ComboboxInput as HeadlessComboboxInput,
  ListboxOptions as HeadlessListboxOptions,
} from "@headlessui/vue";
import type {
  ButtonHTMLAttributes,
  HTMLAttributes,
  InputHTMLAttributes,
} from "vue";

/**
 * Headless UI 1.7 components retyped to accept the attributes of the element they render.
 *
 * At runtime every undeclared attribute and listener falls through to that element, and the template
 * relies on it (`placeholder` and `@input` on the combobox input, for one), but the library's types list
 * only its own props, so strict template checks reject them. The listeners can't move to Headless UI's
 * own events or to a wrapping element without reordering them against Headless UI's handlers, which
 * the components here depend on. The types assume the default `as` element; pass `as` and the attributes
 * stop matching what is rendered.
 */
type RenderingElement<
  Component extends abstract new (...args: never) => object,
  ElementAttributes,
> = new (
  ...args: ConstructorParameters<Component>
) => InstanceType<Component> & { $props: ElementAttributes };

export const ComboboxInput = HeadlessComboboxInput as RenderingElement<
  typeof HeadlessComboboxInput,
  InputHTMLAttributes
>;

export const ComboboxButton = HeadlessComboboxButton as RenderingElement<
  typeof HeadlessComboboxButton,
  ButtonHTMLAttributes
>;

export const ListboxOptions = HeadlessListboxOptions as RenderingElement<
  typeof HeadlessListboxOptions,
  HTMLAttributes
>;
